import { RotatingLines } from "react-loader-spinner";
import { useState, useEffect, useRef } from "react";
import Constants from "../../../Constants";
import SuccessMessage from "../../../components/SuccessMessage";
import jQuery from "jquery";

export default function VidyardCredential (props) {

  const apiTokenRef = useRef(null);

  const credentialData = props.credentialData;
  const [errorMessages, setErrorMessages] = useState(props.errorMessages);
  const [successMessage, setSuccessMessage] = useState(props.successMessage);
  const [apiToken, setApiToken] = useState(apiTokenRef.current?.value);

  useEffect(() => {
    if (props.errorMessages?.length > 0) {
      setErrorMessages(props.errorMessages)
    }
  }, [props.errorMessages])

  useEffect(()=>{
    if(props.successMessage!==Constants.BLANK){
      setSuccessMessage(props.successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
      },5000);
    }
  },[props.successMessage]);

  useEffect(() => {
    const saveCredentialButton = jQuery("#save-credential");
    const validateEloquaCredButton = jQuery("#validate-credential");
    if (apiToken?.length > 0) {
      saveCredentialButton?.removeAttr("disabled");
      validateEloquaCredButton?.removeAttr("disabled");
    } else {
      saveCredentialButton?.attr("disabled",  "true")
      validateEloquaCredButton?.attr("disabled", "true")
    }
  }, [apiToken]);

  const onChnageInputFields = () => {
    setApiToken(apiTokenRef.current?.value);
  }

  return (
    <>
    <div className={props.isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
    </div> 
    {errorMessages?.length > 0 &&
      <><ul id="brightcoveServerError" className="list-error">
      {errorMessages?.map(error => {
        return (<li>{JSON.stringify(error)}</li>) 
      })}
      </ul><br/></>
    }
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}

     <div className="global-dropdown-block mr-0">
      <label>Api Token</label>
        <div className="global-dropdown-select">
          <input id="vidyard-api-token-input" type="text" className="form-control-sm" placeholder="Api Token" defaultValue={credentialData?.credentials?.API_TOKEN} 
          ref={apiTokenRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
    </>
  )
}


